const GlobalFilter = ({ filtering, setFiltering, placeholder = "Search" }) => {
    return (
        <input
            type="search"
            className="form-control px-4 py-2"
            value={filtering || ""}
            placeholder={placeholder}
            onChange={(e) => setFiltering(e.target.value)}
        />
    );
};

export default GlobalFilter;
